import 'slick-carousel'

export default () => {
  $('.review__slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: `<button type="button" class="slick-prev first-arrow">
                  <svg width="6" height="9" viewBox="0 0 6 9" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.64278 0.244846L5.07226 0.679896C5.12962 0.737866 5.1582 0.804645 5.1582 0.88014C5.1582 0.955452 5.12962 1.0222 5.07226 1.08017L1.69601 4.50013L5.07217 7.91994C5.12953 7.97795 5.15811 8.04469 5.15811 8.1201C5.15811 8.19553 5.12953 8.26228 5.07217 8.32025L4.64266 8.75524C4.58543 8.81333 4.51953 8.84229 4.44506 8.84229C4.37064 8.84229 4.30474 8.81324 4.24751 8.75524L0.244082 4.70029C0.18682 4.64232 0.158203 4.57554 0.158203 4.50013C0.158203 4.42473 0.18682 4.35807 0.244082 4.30013L4.24751 0.244846C4.30477 0.186876 4.37067 0.158074 4.44506 0.158074C4.51953 0.158074 4.58543 0.186876 4.64278 0.244846Z" />
                  </svg>
                </button>`,
    nextArrow: `<button type="button" class="slick-next first-arrow">
                  <svg width="6" height="9" viewBox="0 0 6 9" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.35722 0.244846L0.927735 0.679896C0.870383 0.737866 0.841797 0.804645 0.841797 0.88014C0.841797 0.955452 0.870383 1.0222 0.927735 1.08017L4.30399 4.50013L0.927826 7.91994C0.870473 7.97795 0.841887 8.04469 0.841887 8.1201C0.841887 8.19553 0.870473 8.26228 0.927826 8.32025L1.35734 8.75524C1.41457 8.81333 1.48047 8.84229 1.55494 8.84229C1.62936 8.84229 1.69526 8.81324 1.75249 8.75524L5.75592 4.70029C5.81318 4.64232 5.8418 4.57554 5.8418 4.50013C5.8418 4.42473 5.81318 4.35807 5.75592 4.30013L1.75249 0.244846C1.69523 0.186876 1.62933 0.158074 1.55494 0.158074C1.48047 0.158074 1.41457 0.186876 1.35722 0.244846Z" />
                  </svg>
                </button>`,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js